export default __webpack_public_path__ + "c3e3a983065cb98b8c4ec8bbffa50136.png";